import { motion } from "framer-motion";
import { ReactNode, MouseEvent, CSSProperties } from "react";
import { ButtonHTMLAttributes } from "react";

export type ButtonProps = {
	children: ReactNode;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => any;
	className?: string;
	whileTapProps?: {};
	whileHoverProps?: {};
	disabled?: boolean;
	type?: "button" | "submit" | "reset" | undefined;
	id?: string;
	style?: CSSProperties;
	testId?: string;
	title?: string;
};

const Button = ({
	onClick,
	children,
	className,
	whileTapProps,
	whileHoverProps,
	disabled,
	type,
	id,
	style,
	testId,
	title: tooltip,
}: ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps) => {
	return (
		<motion.button
			onClick={onClick}
			id={id}
			data-testid={testId}
			disabled={disabled}
			type={type ? type : "button"}
			title={tooltip}
			className={
				disabled
					? className
					: `clickable bg-transparent ${className ?? ""} ${disabled ? " op-8" : ""
					}`
			}
			whileHover={disabled ? {} : { scale: 1.05, ...whileHoverProps }}
			whileTap={disabled ? {} : { scale: 0.95, ...whileTapProps }}
			style={style}
		>
			{children}
		</motion.button>
	);
};

export default Button;
